import axios from 'api/axios';

export const getTemplates = async () =>
    axios<KIARA_API.TemplateResponse[]>({ url: 'kiara-templates', method: 'GET' }, true);

export const getTemplate = async (id: string) =>
    axios<KIARA_API.TemplateResponse>({ url: `kiara-templates/${id}`, method: 'GET' }, true);
